var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "classify"
  }, [_c('el-dropdown', {
    staticClass: "title"
  }, [_c('ul', {
    staticClass: "content"
  }, _vm._l(_vm.productTypeList, function (item, index) {
    return _c('li', {
      key: index,
      on: {
        "mouseenter": function mouseenter($event) {
          return _vm.dropdownClick(item.id);
        }
      }
    }, [_vm._v(_vm._s(item.typeName))]);
  }), 0), _c('el-dropdown-menu', {
    staticClass: "dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('ul', {
    staticClass: "menu-item content"
  }, _vm._l(_vm.productTypeChildren, function (item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function click($event) {
          return _vm.goDetails(item.id);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.picImagePath.sourceUrl
      }
    }), _c('span', [_vm._v(_vm._s(item.typeName))])]);
  }), 0)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };